import * as React from "react";
import { observer } from "mobx-react";
import { AuthenticationState } from "bernie-context";
import { TripAttachQualificationProps } from "./typings";
import { TripAttachQualificationView } from "./TripAttachQualificationView";
import { TripAttachLoadingView } from "./components/TripAttachLoadingView";
import { withStores } from "stores";
import { Experiment as Experiments, isVariantEnabled } from "src/components/utility/experiment";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";

export enum TripAttachQualificationMipType {
  HOTMIP = "HOTMIP",
  CARMIP = "CARMIP",
}

export const TripAttachQualification = withStores(
  "compositionStore",
  "flexViewModel"
)(
  observer((props: TripAttachQualificationProps) => {
    if (!props.compositionStore) {
      return null;
    }

    if (props.context.user.authState !== AuthenticationState.AUTHENTICATED) {
      return null;
    }

    const { SDUI_Trips_Total_Throttle, PWA_Trips_Important_SF, Trips_PWA_SDUI_Rollout } = Experiments;

    const isTripsExperimentEnabled = isVariantEnabled(props.context, PWA_Trips_Important_SF);

    const [isLoading, setLoading] = React.useState(true);

    React.useEffect(() => {
      if (props.compositionStore) {
        props.compositionStore
          .updateModule({ fmId: flexComponent.fmId })
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }, []);

    const { flexComponent } = props;
    if (
      !(
        flexComponent.model &&
        flexComponent.model.destinationName &&
        flexComponent.model.tripStartDate &&
        flexComponent.model.tripEndDate &&
        flexComponent.model.deepLink &&
        flexComponent.model.deepLinkMipType &&
        flexComponent.model.percentageOff
      )
    ) {
      return isLoading ? <TripAttachLoadingView /> : null;
    }

    if (isTripsExperimentEnabled) {
      return (
        <Viewport>
          <ViewSmall />
          <ViewMedium>
            <TripAttachQualificationView
              deepLink={flexComponent.model.deepLink}
              deepLinkMipType={flexComponent.model.deepLinkMipType}
              destinationName={flexComponent.model.destinationName}
              imageData={flexComponent.model.imageData}
              moduleName={flexComponent.name}
              percentageOff={flexComponent.model.percentageOff}
              tripEndDate={flexComponent.model.tripEndDate}
              tripStartDate={flexComponent.model.tripStartDate}
            />
          </ViewMedium>
        </Viewport>
      );
    }

    return (
      <Experiment name={SDUI_Trips_Total_Throttle}>
        <ExperimentControl>
          <Experiment name={Trips_PWA_SDUI_Rollout}>
            <ExperimentControl>
              <TripAttachQualificationView
                deepLink={flexComponent.model.deepLink}
                deepLinkMipType={flexComponent.model.deepLinkMipType}
                destinationName={flexComponent.model.destinationName}
                imageData={flexComponent.model.imageData}
                moduleName={flexComponent.name}
                percentageOff={flexComponent.model.percentageOff}
                tripEndDate={flexComponent.model.tripEndDate}
                tripStartDate={flexComponent.model.tripStartDate}
              />
            </ExperimentControl>
            <ExperimentVariant bucket={1} />
          </Experiment>
        </ExperimentControl>
        <ExperimentVariant bucket={1} />
      </Experiment>
    );
  })
);

export default TripAttachQualification;
